import { Copy, Share2 } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const BULAN = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];
const stamp = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}-${BULAN[d.getMonth()]}-${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export function TrCodesDialog({ item, onClose, onCopy, onShare }) {
  return (
    <Dialog open={!!item} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-xl" data-testid="dialog-tr-codes">
        <DialogHeader><DialogTitle>Kode Voucher TUAN-RUMAH — {item?.router_name}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 max-h-80 overflow-y-auto bg-white p-2 rounded-md" data-testid="tr-codes-grid">
          {(item?.codes || []).map((c, i) => (
            <div key={c} className="flex flex-col justify-between border border-neutral-500 rounded-sm px-2 py-1.5 leading-tight text-black bg-white" data-testid={`tr-code-${c}`}>
              <div className="text-[9px] font-bold uppercase tracking-wide truncate">{item.router_name}</div>
              <div className="font-mono font-bold text-[22px] leading-none text-center tracking-wider my-1">{c}</div>
              <div className="flex justify-between text-[9px] font-semibold"><span>TUAN RUMAH</span><span className="font-normal">login: fas.net</span></div>
              <div className="text-[7.5px] text-neutral-700">Cetak: {stamp(item.created_at)} [{i + 1}]</div>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={onCopy} data-testid="btn-tr-copy-codes"><Copy className="w-4 h-4 mr-1.5" /> Salin Semua Kode</Button>
          <Button className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-white" onClick={onShare} data-testid="btn-tr-share-wa"><Share2 className="w-4 h-4 mr-1.5" /> Bagikan WA</Button>
        </div>
        <p className="text-[11px] text-muted-foreground">Username = password. Profile TUAN-RUMAH, masa aktif 30 hari sejak login pertama.</p>
      </DialogContent>
    </Dialog>
  );
}
